module.exports = __webpack_public_path__ + "static/media/fixtures.481c0c10.svg";